import { PatientAddress } from '@types';

export function parsePlaceResultToAddress(
  place: google.maps.places.PlaceResult,
): PatientAddress | undefined {
  if (!place?.address_components) {
    return;
  }

  const address: PatientAddress = {
    streetAddress1: '',
    streetAddress2: undefined,
    city: '',
    stateCode: '',
    zip: '',
    countryCode: '',
  };
  place.address_components.forEach((component) => {
    const { long_name, short_name, types } = component;

    if (types.includes('street_number')) {
      address.streetAddress1 = long_name;
      return;
    }

    if (types.includes('route')) {
      address.streetAddress1 = `${address.streetAddress1} ${long_name}`;
      return;
    }

    if (types.includes('subpremise')) {
      address.streetAddress2 = long_name;
      return;
    }

    if (types.includes('locality')) {
      address.city = long_name;
      return;
    }

    if (types.includes('sublocality')) {
      address.city = long_name;
      return;
    }

    if (types.includes('administrative_area_level_1')) {
      address.stateCode = short_name;
      return;
    }

    if (types.includes('postal_code')) {
      address.zip = long_name;
      return;
    }

    if (types.includes('country')) {
      address.countryCode = short_name;
      return;
    }
  });

  return address;
}
